import React from 'react';
import { Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import useExport from '@components/export/useExport';
import { track } from '@utils';
import { CLICK_EXPORT_AI_ALERTS_SUMMARY_TABLE } from '@src/utils/sensor/track';

export const exportConfig = {
  page: { key: 'ai-alerts-summary', title: 'AI Alerts Summary' },
  sections: [{ key: 'ai-alerts-summary', title: 'AI Alerts Summary' }],
};

function ExportTable({ title }: { title?: string }) {
  const { triggerDownload } = useExport({ config: exportConfig });

  const handleClickExport = () => {
    track({ event: CLICK_EXPORT_AI_ALERTS_SUMMARY_TABLE });
    triggerDownload();
  };

  return (
    <Button
      onClick={handleClickExport}
      icon={
        <Tooltip title={title || 'Export'}>
          <DownloadOutlined />
        </Tooltip>
      }
    />
  );
}

export default ExportTable;
